import { customStyle, REGEX } from "components/Common/constants";
import React, { useRef, useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  FormGroup,
  Label,
  Container,
  Badge,
  InputGroupAddon,
  UncontrolledTooltip,
} from "reactstrap";
import Select, { components } from "react-select";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { renderStars, showAlert } from "components/Common/commonFunctions";
import CommonTable from "components/ReactTable/Table";
import NotificationAlert from "react-notification-alert";
import AvailabilitySelector from "./AvailabilitySelector";
import Breadcrumbs from "components/Common/BreadCrumbs";
import {
  getRegionList,
  getSpecializationList,
  getTechnicianById,
  changeTechnicianPassword,
  editTechnician,
} from "actions/technicians";
import { useDispatch, useSelector } from "react-redux";
import { urlDecodedId } from "components/Common/encodeDecodeFunction";
import {
  getTimeSlotsList,
  getTechncianAvailablityByID,
} from "actions/technicianAvailability";
import { DEFAULT_RECORDS_PER_PAGE } from "components/Common/constants";
import { getTechnicianLeave } from "actions/technicianLeave";
import TechnicianLeaveModal from "./TechnicianLeaveModal";

const initialFields = {
  firstName: {
    value: "",
    error: "",
    isChanged: false,
  },
  lastName: {
    value: "",
    error: "",
    isChanged: false,
  },
  email: {
    value: "",
    error: "",
    isChanged: false,
  },
  password: {
    value: "",
    error: "",
    isChanged: false,
  },
  phoneNo: {
    value: "",
    error: "",
    isChanged: false,
  },
  region: {
    value: null,
    error: "",
    isChanged: false,
  },
  specializations: {
    value: [],
    error: "",
    isChanged: false,
  },
  isOnlineJob: {
    value: "NO",
    error: "",
    isChanged: false,
  },
};

const changePasswordFields = {
  password: {
    value: "",
    error: "",
  },
  confirmPassword: {
    value: "",
    error: "",
  },
};
function TechnicianDetails() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const notificationAlertRef = useRef(null);
  const regionList = useSelector((state) => state.technicians.regionList);
  const specializationList = useSelector(
    (state) => state.technicians.specializationList
  );
  //get technician leave list
  const getTechnicianLeaveList = useSelector(
    (state) => state.technicianLeave.technicianLeaveList
  );
  const [pageNum, setPageNum] = useState(1);
  const formattedTechnicianLeaveList =
    getTechnicianLeaveList?.data?.technicianLeave?.map((item, index) => {
      return {
        ...item,
        srNo:
          (pageNum - 1) *
          (getTechnicianLeaveList?.data?.noOfRecordsPerPage ||
            DEFAULT_RECORDS_PER_PAGE) +
          index +
          1,
      };
    });
  const queryParams = new URLSearchParams(location.search);
  const urlTab = queryParams.get("tab");
  const isEditFromUrl = queryParams.get("edit") === "true";
  const [technician, setTechnician] = useState(null);
  const [technicianFormData, setTechnicianFormData] = useState(initialFields);
  const [technicianPassword, setTechnicianPassword] =
    useState(changePasswordFields);
  const [showAlternative, setShowAlternative] = useState({
    loader: false,
    error: "",
  });
  const [activeTab, setActiveTab] = useState(urlTab || "details");
  const [isEditing, setIsEditing] = useState(isEditFromUrl);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showLoaderOnClick, setShowLoaderOnClick] = useState(false);
  const [showLoaderPasswordSave, setShowLoaderOnPasswordSave] = useState(false);
  const [technicianAvailability, setTechnicianAvailability] = useState(null);
  const [leaveModal, setLeaveModal] = useState({
    isOpen: false,
    mode: "ADD", // "ADD" or "EDIT"
    data: null,
  });
  const [technicianLeaveListState, setTechnicianLeaveListState] = useState({
    isLoading: true,
    error: "",
    noRecords: false,
  });

  //decode id here from url
  const decodedId = id ? urlDecodedId(id) : null;
  useEffect(() => {
    getRegionList(dispatch);
    getSpecializationList(dispatch);
  }, []);

  useEffect(() => {
    if (decodedId) {
      getTechnicianDetails(decodedId);
    }
  }, [decodedId]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    // get the tab parameter if not present set by default as details tab 
    setActiveTab(params.get("tab") || "details");
  }, [location.search]);

  //if activeTab is technicianAvailability with id get ->data
  useEffect(() => {
    if (activeTab === "availability" && decodedId) {
      getTechnicianAvailability(decodedId);
      getTimeSlotsList(dispatch);
    }
  }, [activeTab, decodedId]);

  //if activeTab is techncian leave with id get ->data
  useEffect(() => {
    if (activeTab === "leaves") {
      setTechnicianLeaveListState({
        isLoading: true,
        error: "",
        noRecords: false,
      });
      getTechnicianLeave(decodedId, dispatch);
    }
  }, [activeTab, decodedId, dispatch]);

  useEffect(() => {
    if (getTechnicianLeaveList?.code === 200) {
      setTechnicianLeaveListState({
        isLoading: false,
        error: "",
        noRecords: getTechnicianLeaveList?.data?.technicianLeave?.length === 0,
      });
    } else if (
      getTechnicianLeaveList?.code ||
      getTechnicianLeaveList?.message
    ) {
      setTechnicianLeaveListState({
        isLoading: false,
        error:
          getTechnicianLeaveList?.message ||
          "Something went Wrong! Please try again.",
        noRecords: false,
      });
    }
  }, [getTechnicianLeaveList]);

  const notify = (type, message) => {
    const options = {
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  //get technician details by id
  const getTechnicianDetails = async (id) => {
    try {
      setShowAlternative({ loader: true, error: false });
      const res = await getTechnicianById(id);
      if (res.code === 200) {
        const technicianDetails = res?.data;
        setTechnician(technicianDetails);
        setTechnicianFormData({
          firstName: { value: technicianDetails?.firstName || "", error: "" },
          lastName: { value: technicianDetails?.lastName || "", error: "" },
          email: { value: technicianDetails?.email || "", error: "" },
          phoneNo: { value: technicianDetails?.phoneNo || "", error: "" },
          region: { value: technicianDetails?.region || "", error: "" },
          specializations: {
            value: technicianDetails?.specializations || "",
            error: "",
          },
          isOnlineJob: {
            value: technicianDetails?.isOnlineJob === "YES" ? "YES" : "N",
            error: "",
          },
        });
        setShowAlternative({ loader: false, error: false });
      } else {
        setShowAlternative({ loader: false, error: "" });
        const message = Array.isArray(res?.message)
          ? res.message
            .map((err) => (err.Msg ? err.Msg : JSON.stringify(err)))
            .join(", ")
          : res?.message || "Failed to load Technician details!";
        notify("danger", message);
      }
    } catch (error) {
      setShowAlternative({
        loader: false,
        error: error || "Failed to load Technician details!",
      });
    }
  };

  //get techncian availability by id
  const getTechnicianAvailability = async (id) => {
    try {
      setShowAlternative({ loader: true, error: false });

      const res = await getTechncianAvailablityByID(id);

      if (res.code === 200) {
        setTechnicianAvailability(res?.data?.availability || {});

        setShowAlternative({ loader: false, error: false });
      } else {
        setShowAlternative({ loader: false, error: true });
        const message = Array.isArray(res?.message)
          ? res.message
            .map((err) => (err.Msg ? err.Msg : JSON.stringify(err)))
            .join(", ")
          : res?.message || "Failed to load Technician availability!";
        notify("danger", message);
      }
    } catch (error) {
      setShowAlternative({
        loader: false,
        error: error || "Failed to load Technician availability!",
      });
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
    setIsEditing(false);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", tab); //added tab
    searchParams.delete("edit");
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
    setShowPassword(false);
    setShowConfirmPassword(false);
  };

  const handleEditClick = () => {
    setIsEditing(true);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("edit", "true");
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });

    setTechnicianFormData({
      firstName: { value: technician?.firstName || "", error: "" },
      lastName: { value: technician?.lastName || "", error: "" },
      email: { value: technician?.email || "", error: "" },
      region: { value: technician?.region || "", error: "" },
      specializations: { value: technician?.specializations || "", error: "" },
      phoneNo: { value: technician?.phoneNo || "", error: "" },
      isOnlineJob: { value: technician?.isOnlineJob || "", error: "" },
    });
  };
  const handleInputChange = (fieldName, newValue) => {
    setTechnicianFormData((prev) => ({
      ...prev,
      [fieldName]: {
        value: newValue,
        error: "",
      },
    }));
  };

  const handlePasswordInputChange = (fieldName, newValue) => {
    setTechnicianPassword((prev) => ({
      ...prev,
      [fieldName]: {
        value: newValue,
        error: "",
      },
    }));
  };
  const getValidationError = (name, value) => {
    switch (name) {
      case "firstName":
        return !value
          ? "Please enter a first name"
          : value.length < 2
            ? "First name must be at least 2 characters"
            : value.length > 50
              ? "First name must be less than 50 characters"
              : "";

      case "lastName":
        return !value
          ? "Please enter a last name"
          : value.length < 2
            ? "Last name must be at least 2 characters"
            : value.length > 50
              ? "Last name must be less than 50 characters"
              : "";
      case "email":
        return !value
          ? "Please enter an email"
          : !REGEX.EMAIL_REGEX.test(value)
            ? "Please enter a valid email"
            : "";
      case "password":
        return !value
          ? "Please enter a password"
          : value.length < 8
            ? "Password must contain 8 characters"
            : "";
      case "phoneNo":
        return !value
          ? "Please enter your contact no"
          : value.length < 9
            ? "Contact number must be 9 digits"
            : !REGEX.CONTACT_REGEX.test(value)
              ? "Contact number must contain only valid digits"
              : "";
      case "region":
        return !value ? "Please select a region" : "";
      case "specializations":
        return !value ? "Please select a specialization" : "";
      default:
        return "";
    }
  };

  const getValidationErrorPassword = (name, value) => {
    switch (name) {
      case "password":
        return !value
          ? "Please enter a password"
          : value.length < 8
            ? "The password must contain 8 characters"
            : technicianPassword.confirmPassword.value &&
              value !== technicianPassword.confirmPassword.value
              ? "The new password and confirm password must match"
              : "";
      case "confirmPassword":
        return !value
          ? "Please enter a confirm password"
          : technicianPassword.password.value &&
            value !== technicianPassword.password.value
            ? "The new password and confirm password must match"
            : "";
      default:
        return "";
    }
  };
  const validateForm = () => {
    let newTechnician = { ...technicianFormData };

    //get all the keys in array
    Object.keys(newTechnician).forEach((key) => {
      newTechnician[key] = {
        ...newTechnician[key],
        error: getValidationError(key, newTechnician[key].value),
      };
    });
    setTechnicianFormData(newTechnician); //if error set error state
    return Object.values(newTechnician).every((item) => item.error === "");
  };

  const validatePasswordForm = () => {
    let newPassword = { ...technicianPassword };

    Object.keys(newPassword).forEach((key) => {
      newPassword[key] = {
        ...newPassword[key],
        error: getValidationErrorPassword(key, newPassword[key].value),
      };
    });

    setTechnicianPassword(newPassword); // set the error state
    return Object.values(newPassword).every((item) => item.error === "");
  };
  const handleSave = async () => {
    if (validateForm()) {
      try {
        setShowLoaderOnClick(true);

        // Convert specialization to array of arrays -> specialization (IDs) for sending multiple IDs in array
        const specializationIDs = Array.isArray(
          technicianFormData.specializations.value
        )
          ? technicianFormData.specializations.value.map((s) => s.ID)
          : technicianFormData.specializations.value?.ID
            ? [technicianFormData.specializations.value.ID]
            : [];
        const bodyData = {
          firstName: technicianFormData.firstName.value,
          lastName: technicianFormData.lastName.value,
          email: technicianFormData.email.value,
          phoneNo: technicianFormData.phoneNo.value,
          regionID: technicianFormData.region.value.ID,
          specializations: specializationIDs,
          isOnlineJob: technicianFormData.isOnlineJob.value,
        };

        const res = await editTechnician(decodedId, bodyData);
        if (res.code === 200) {
          notify("success", res.message || "Technician updated successful");
          await getTechnicianDetails(decodedId);

          setIsEditing(false);
          const searchParams = new URLSearchParams(location.search);
          searchParams.delete("edit");
          navigate(`${location.pathname}?${searchParams.toString()}`, {
            replace: true,
          });
        } else {
          setShowAlternative({ loader: false, error: "" });
          const message = Array.isArray(res?.message)
            ? res.message
              .map((err) => (err.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
            : res?.message || "Failed to update Technician!";
          notify("danger", message);
        }
      } catch (e) {
        notify("danger", "Failed to update Technician!");
      } finally {
        setShowLoaderOnClick(false);
      }
    }
  };

  const handlePasswordSaveClick = async () => {
    if (validatePasswordForm()) {
      try {
        setShowLoaderOnPasswordSave(true);
        const bodyData = {
          newPassword: technicianPassword.password.value,
          confirmNewPassword: technicianPassword.confirmPassword.value,
        };
        const res = await changeTechnicianPassword(decodedId, bodyData);
        if (res.code === 200) {
          notify("success", res.message || "Password changed successfully");
          setTechnicianPassword(changePasswordFields);
        } else {
          const message = Array.isArray(res?.message)
            ? res.message
              .map((err) => (err.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
            : res?.message || "Failed to change password!";
          notify("danger", message);
        }
      } catch (e) {
        notify("danger", "Failed to change password!");
      } finally {
        setShowLoaderOnPasswordSave(false);
      }
    }
  };
  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setTechnicianFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };
  const handleOnBlurPassForm = (name, value) => {
    const error = getValidationErrorPassword(name, value);
    setTechnicianPassword((prev) => ({
      ...prev,
      [name]: { ...prev[name], error },
    }));
  };

  const ChangeStatus = async (newStatus) => {
    try {
      setShowLoaderOnClick(true);
      const bodyData = {
        status: newStatus,
      };
      const res = await editTechnician(decodedId, bodyData);
      if (res.code === 200) {
        notify(
          "success",
          res.message || "Technician status updated successfully"
        );
        await getTechnicianDetails(decodedId);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to update technician status!";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", "Failed to update status");
    }
  };

  const handleAddLeave = () => {
    setLeaveModal({
      isOpen: true,
      mode: "ADD",
      data: null,
    });
  };

  const handleCloseLeaveModal = () => {
    setLeaveModal({
      isOpen: false,
      mode: "ADD",
      data: null,
    });
  };
  const openEditModal = (rowData) => {
    setLeaveModal({
      isOpen: true, //open the modal
      mode: "EDIT",
      data: rowData, // pass the row data to autofill the form in edit mode
    });
  };

  const SpecializationOption = (props) => {
    const { isSelected, label } = props;

    return (
      <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => null}
            style={{ marginRight: 8 }}
          />
          <span>{label}</span>
        </div>
      </components.Option>
    );
  };
  const handleStatusChangeModal = () => {
    showAlert({
      title: `Are you sure you want to ${technician?.status === "ACTIVE" ? "suspend" : "activate"
        } this technician?`,
      message: `Technician "${technician?.fullName}" will be ${technician?.status === "ACTIVE" ? "suspended" : "activated"
        }.`,
      type: "warning",
      confirmStyle: "default",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => {
        ChangeStatus(technician?.status === "ACTIVE" ? "SUSPENDED" : "ACTIVE");
      },
      onCancel: () => { },
    });
  };

  const columns = [
    { Header: "Sr.no.", accessor: "srNo", className: "col-srNo", },
    { Header: "Requested On", accessor: "requestedOn" },
    { Header: "Start Date", accessor: "startDate" },
    { Header: "End Date", accessor: "endDate" },
    { Header: "Reason", accessor: "reason" },
    {
      Header: "Actions",
      accessor: "ID",
      disableSortBy: true,
      className: "text-center",
      Cell: ({ row }) => (
        <div className="actions-right d-flex justify-content-start">
          <Button
            onClick={() => openEditModal(row.original)}
            color="link"
            size="sm"
            className="btn-icon btn-neutral ml-1 icon-info"
            id={`edit${row.original.ID}`}
          >
            <i className="tim-icons icon-pencil tim-md" />
          </Button>
          <UncontrolledTooltip delay={0} target={`edit${row.original.ID}`}>
            Edit
          </UncontrolledTooltip>
        </div>
      ),
    },
  ];

  const handleCancel = () => {
    setIsEditing(false);

    setTechnicianFormData({
      firstName: { value: technician?.firstName || "", error: "" },
      lastName: { value: technician?.lastName || "", error: "" },
      email: { value: technician?.email || "", error: "" },
      region: { value: technician?.region || "", error: "" },
      specializations: { value: technician?.specializations || "", error: "" },
      phoneNo: { value: technician?.phoneNo || "", error: "" },
      isOnlineJob: { value: technician?.isOnlineJob || "", error: "" },
    });
    // Remove the ?edit=true from URL
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("edit");
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Container fluid className="mt-4">
        <Breadcrumbs
          items={[
            { name: "Technicians", link: "/admin/technicians" },
            { name: `${technician?.fullName}` },
          ]}
        />

        <Row>
          <Card className="m-3 shadow-sm border-0">
            <>
              <div className="custom-tabs-wrapper" style={{ 
                  width: '100%', 
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  <Nav className="custom-tabs">
                    <NavItem>
                      <NavLink
                        className={`text-center ${activeTab === "details" ? "active" : ""}`}
                        onClick={() => toggleTab("details")}
                      >
                        Technician Details
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={`text-center ${activeTab === "availability" ? "active" : ""}`}
                        onClick={() => toggleTab("availability")}
                      >
                        Technician Availability
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={`text-center ${activeTab === "leaves" ? "active" : ""}`}
                        onClick={() => toggleTab("leaves")}
                      >
                        Leaves
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={`text-center ${activeTab === "change_password" ? "active" : ""}`}
                        onClick={() => toggleTab("change_password")}
                      >
                        Change Password
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>

              <CardBody>
                {showAlternative.loader ? (
                  <div className="loaderContainer">
                    <i className="fa fa-spinner fa-spin fa-2xl loader" />
                  </div>
                ) : showAlternative.error ? (
                  <div className="loaderContainer text-muted d-flex flex-column">
                    <h4 className="text-muted">No Technician Data Available</h4>
                    <span className="text-danger">{showAlternative.error}</span>
                  </div>
                ) : (
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="details">
                      <Row className="justify-content-center">
                        <Col md={12} lg={12}>
                         <Row className="d-flex justify-content-end mx-0 mb-3">
                            {!isEditing && (
                              <>
                                <div className="d-flex" style={{ gap: '8px' }}>
                                  <Button
                                    color="default"
                                    size="sm"
                                    onClick={handleEditClick}
                                    className="px-3"
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    <i className="fa fa-pencil mr-2" /> Edit
                                  </Button>

                                  <Button
                                    color="secondary"
                                    size="sm"
                                    onClick={() => handleStatusChangeModal()}
                                    className="px-3"
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    <i
                                      className={`fa ${technician?.status === "ACTIVE"
                                        ? "fa-user-slash"
                                        : "fa-user"
                                      } mr-2`}
                                    />
                                    {technician?.status === "ACTIVE" ? "Suspend" : "Activate"}
                                  </Button>
                                </div>
                              </>
                            )}
                          </Row>

                          <Row className="px-3">
                            <Col md={4} className="mb-2">
                              <FormGroup
                                className={`has-label ${technicianFormData.firstName.error
                                  ? "has-danger"
                                  : ""
                                  } d-flex flex-column align-items-start`}
                              >
                                <Label>
                                  First Name
                                  {isEditing && <span className="validation-error">{" "}*</span>}
                                </Label>

                                {isEditing ? (
                                  <>
                                    <Input
                                      name="firstName"
                                      type="text"
                                      placeholder="Enter first name"
                                      value={technicianFormData.firstName.value}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                      onBlur={(e) =>
                                        handleOnBlur(
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                      required
                                      maxLength={50}
                                    />
                                    {technicianFormData.firstName.error && (
                                      <small className="validation-error">
                                        {technicianFormData.firstName.error}
                                      </small>
                                    )}
                                  </>
                                ) : (
                                  <span className="small-text text-wrap">
                                    {technician?.firstName}
                                  </span>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md={4} className="mb-2">
                              <FormGroup
                                className={`has-label ${technicianFormData.lastName.error
                                  ? "has-danger"
                                  : ""
                                  } d-flex flex-column align-items-start`}
                              >
                                <Label>
                                  Last Name
                                  {isEditing && <span className="validation-error">{" "}*</span>}
                                </Label>

                                {isEditing ? (
                                  <>
                                    <Input
                                      name="lastName"
                                      type="text"
                                      placeholder="Enter last name"
                                      value={technicianFormData.lastName.value}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                      onBlur={(e) =>
                                        handleOnBlur(
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                      required
                                      maxLength={50}
                                    />
                                    {technicianFormData.lastName.error && (
                                      <small className="validation-error">
                                        {technicianFormData.lastName.error}
                                      </small>
                                    )}
                                  </>
                                ) : (
                                  <span className="small-text text-wrap">
                                    {technician?.lastName}
                                  </span>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md={4} className="mb-2">
                              <FormGroup
                                className={`has-label ${technicianFormData.email.error
                                  ? "has-danger"
                                  : ""
                                  } d-flex flex-column align-items-start`}
                              >
                                <Label>
                                  Email Address
                                  {isEditing && <span className="validation-error">{" "}*</span>}
                                </Label>
                                {isEditing ? (
                                  <>
                                    <Input
                                      name="email"
                                      type="email"
                                      placeholder="Enter email"
                                      value={technicianFormData.email.value}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                      onBlur={(e) =>
                                        handleOnBlur(
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                      required
                                      maxLength={100}
                                    />
                                    {technicianFormData.email.error && (
                                      <small className="validation-error">
                                        {technicianFormData.email.error}
                                      </small>
                                    )}
                                  </>
                                ) : (
                                  <span className="small-text text-wrap">
                                    {technician?.email}
                                  </span>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md={4} className="mb-2">
                              <FormGroup
                                className={`has-label ${technicianFormData.phoneNo.error
                                  ? "has-danger"
                                  : ""
                                  } d-flex flex-column align-items-start`}
                              >
                                <Label>
                                  Contact Number
                                  {isEditing && <span className="validation-error">{" "}*</span>}
                                </Label>
                                {isEditing ? (
                                  <>
                                    <InputGroup className="input-group">
                                      <InputGroupAddon addonType="prepend">
                                        <InputGroupText className="d-flex align-items-center">
                                          <span className="mr-1">🇸🇦</span> +966
                                        </InputGroupText>
                                      </InputGroupAddon>
                                      <Input
                                        name="phoneNo"
                                        type="tel"
                                        placeholder="Enter contact number"
                                        autoComplete="off"
                                        value={technicianFormData.phoneNo.value}
                                        onChange={(e) =>
                                          handleInputChange(
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        onBlur={(e) =>
                                          handleOnBlur(
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        required
                                        maxLength={9}
                                      />
                                    </InputGroup>
                                    {technicianFormData.phoneNo.error && (
                                      <small className="validation-error">
                                        {technicianFormData.phoneNo.error}
                                      </small>
                                    )}
                                  </>
                                ) : (
                                  <span className="small-text">
                                    +966 {technician?.phoneNo}
                                  </span>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md={4} className="mb-2">
                              <FormGroup className="d-flex flex-column align-items-start">
                                <Label>
                                  Region {isEditing && <span className="validation-error">*</span>}
                                </Label>
                                {isEditing ? (
                                  <>
                                    <Select
                                      className={`text-left ${technicianFormData.region.error
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                      name="region"
                                      classNamePrefix="react-select"
                                      options={regionList?.data?.region}
                                      placeholder="Select region"
                                      styles={customStyle}
                                      value={technicianFormData.region.value}
                                      getOptionLabel={(options) => options.name}
                                      getOptionValue={(options) => options.ID}
                                      onChange={(selectedOption) =>
                                        handleInputChange(
                                          "region",
                                          selectedOption
                                        )
                                      }
                                      onBlur={() =>
                                        handleOnBlur(
                                          "region",
                                          technicianFormData.region.value
                                        )
                                      }
                                      menuPortalTarget={document.body}
                                      menuPosition={"fixed"}
                                    />
                                    {technicianFormData.region.error && (
                                      <small className="validation-error">
                                        {technicianFormData.region.error}
                                      </small>
                                    )}
                                  </>
                                ) : (
                                  <span className="small-text text-wrap">
                                    {technician?.region?.name}
                                  </span>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md={4} className="mb-2">
                              <FormGroup className="d-flex flex-column align-items-start mt-2">
                                <Label className="mr-2 mb-0">
                                  Can perform online jobs? {isEditing && <span className="validation-error">*</span>}
                                </Label>
                                {isEditing ? (
                                  <div className="d-flex align-items-center mt-1">
                                    <Label className="custom-toggle custom-toggle-info mb-0">
                                      <Input
                                        type="checkbox"
                                        checked={
                                          technicianFormData?.isOnlineJob
                                            ?.value === "YES"
                                        }
                                        name="isOnlineJob"
                                        onChange={(e) =>
                                          setTechnicianFormData((prev) => ({
                                            ...prev,
                                            isOnlineJob: {
                                              ...prev.isOnlineJob,
                                              value: e.target.checked
                                                ? "YES"
                                                : "NO",
                                              isChanged: true,
                                            },
                                          }))
                                        }
                                      />

                                      <span
                                        className="custom-toggle-slider rounded-circle"
                                        data-label-off="NO"
                                        data-label-on="YES"
                                      ></span>
                                    </Label>
                                  </div>
                                ) : (
                                  <span className="small-text text-wrap">
                                    {technician?.isOnlineJob}
                                  </span>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md={4} className="mb-2">
                              <FormGroup className="d-flex flex-column align-items-start">
                                <Label>
                                  Specialization
                                  {isEditing && <span className="validation-error">{" "}*</span>}
                                </Label>
                                {isEditing ? (
                                  <>
                                    <Select
                                      className={`text-left ${technicianFormData.specializations.error
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                      name="specialization"
                                      classNamePrefix="react-select p-5"
                                      options={
                                        specializationList?.data?.specialization
                                      }
                                      placeholder="Select specialization"
                                      styles={customStyle}
                                      value={
                                        technicianFormData.specializations.value
                                      }
                                      getOptionLabel={(options) => options.name}
                                      getOptionValue={(options) => options.ID}
                                      onChange={(selectedOption) =>
                                        handleInputChange(
                                          "specializations",
                                          selectedOption
                                        )
                                      }
                                      menuPortalTarget={document.body}
                                      menuPosition={"fixed"}
                                      isMulti
                                      components={{
                                        Option: SpecializationOption,
                                      }}
                                    />
                                    {technicianFormData.specializations
                                      .error && (
                                        <small className="validation-error">
                                          {
                                            technicianFormData.specializations
                                              .error
                                          }
                                        </small>
                                      )}
                                  </>
                                ) : (
                                  <span className="small-text text-wrap ml-4">
                                    {Array.isArray(
                                      technician?.specializations
                                    ) &&
                                      technician.specializations.length > 0 ? (
                                      <ul>
                                        {technician.specializations.map(
                                          (sp) => (
                                            <li
                                              className="li-color"
                                              key={sp.name}
                                            >
                                              {sp.name}
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    ) : (
                                      "--"
                                    )}
                                  </span>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md={4} className="mb-2">
                              <FormGroup className="d-flex flex-column align-items-start mt-2">
                                <Label>Rating</Label>
                                {renderStars(technician?.rating)}
                              </FormGroup>
                            </Col>

                            <Col md={4} className="mb-0">
                              <FormGroup
                                className={`d-flex flex-column align-items-start mt-2`}
                              >
                                <Label>Status</Label>
                                <span>
                                  <Badge
                                    className="px-3 py-2"
                                    color={
                                      technician?.status === "ACTIVE"
                                        ? "success"
                                        : "warning"
                                    }
                                    pill
                                  >
                                    {technician?.status === "INACTIVE"
                                      ? "suspended"
                                      : technician?.status}{" "}
                                  </Badge>
                                </span>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex justify-content-end">
                              {isEditing && (
                                <>
                                  <Button
                                    className="mr-2"
                                    color="secondary"
                                    size="sm"
                                    onClick={handleCancel}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    color="default"
                                    size="sm"
                                    onClick={() => {
                                      handleSave();
                                    }}
                                    disabled={Object.values(
                                      technicianFormData
                                    ).some((item) => item.error !== "")}
                                  >
                                    {showLoaderOnClick ? (
                                      <i className="fa fa-spinner fa-spin fa-lg text-white" />
                                    ) : (
                                      "Save"
                                    )}
                                  </Button>
                                </>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="availability">
                      <Row>
                        <Col>
                          <AvailabilitySelector
                            technicianAvailability={technicianAvailability}
                            technicianID={decodedId}
                          />
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="leaves">
                      <Row className="mt-3">
                        <Col md={12}>
                          <Row className="d-flex justify-content-end mr-2 mb-3">
                            <Button
                              color="default"
                              size="sm"
                              onClick={handleAddLeave}
                            >
                              <i className="fa fa-plus mr-2" /> Add Leave
                            </Button>
                          </Row>

                          {technicianLeaveListState.isLoading ? (
                            <div className="loaderContainer">
                              <i className="fa fa-spinner fa-spin fa-2xl loader" />
                            </div>
                          ) : technicianLeaveListState.error ? (
                            <div className="loaderContainer">
                              {technicianLeaveListState.error}
                            </div>
                          ) : technicianLeaveListState.noRecords ? (
                            <div className="loaderContainer text-muted">
                              There are currently no leave records for this
                              technician
                            </div>
                          ) : (
                            <div className="table-responsive">
                              <CommonTable
                                data={formattedTechnicianLeaveList}
                                resizable={false}
                                columns={columns}
                                defaultPageSize={DEFAULT_RECORDS_PER_PAGE || 25}
                                showPaginationBottom={true}
                                className="-striped -highlight table-hover"
                                activePage={pageNum}
                                setPageNum={setPageNum}
                                totalRecords={Math.ceil(
                                  getTechnicianLeaveList?.data
                                    ?.totalFilterRecords /
                                  (getTechnicianLeaveList?.data
                                    ?.noOfRecordsPerPage ||
                                    DEFAULT_RECORDS_PER_PAGE)
                                )}
                              />
                            </div>
                          )}
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="change_password">
                      <Row className="justify-content-start my-3 px-3">
                        <Col md="4">
                          <FormGroup
                            className={`has-label ${technicianPassword.password.error
                              ? "has-danger"
                              : ""
                              } d-flex flex-column align-items-start mb-4`}
                          >
                            <Label for="newPassword">
                              New Password{" "}
                              <span className="validation-error">*</span>
                            </Label>
                            <InputGroup className="input-group">
                              <Input
                                name="password"
                                type={showPassword ? "text" : "password"}
                                autoComplete="off"
                                placeholder="Enter new password"
                                value={technicianPassword.password.value}
                                onChange={(e) =>
                                  handlePasswordInputChange(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>
                                  handleOnBlurPassForm(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                                required
                                maxLength={16}
                              />
                              <InputGroupAddon addonType="append">
                                <InputGroupText
                                  className="d-flex align-items-center pointer"
                                  onClick={() =>
                                    setShowPassword((prev) => !prev)
                                  }
                                >
                                  {showPassword ? (
                                    <i className="fa fa-eye-slash" />
                                  ) : (
                                    <i className="fa fa-eye" />
                                  )}
                                </InputGroupText>
                              </InputGroupAddon>
                            </InputGroup>
                            {technicianPassword.password.error && (
                              <small className="validation-error">
                                {technicianPassword.password.error}
                              </small>
                            )}
                          </FormGroup>
                          <FormGroup
                            className={`has-label ${technicianPassword.confirmPassword.error
                              ? "has-danger"
                              : ""
                              } d-flex flex-column align-items-start mb-4`}
                          >
                            <Label for="confirmPassword">
                              Confirm New Password{" "}
                              <span className="validation-error">*</span>
                            </Label>
                            <InputGroup className="input-group">
                              <Input
                                id="confirmPassword"
                                name="confirmPassword"
                                type={showConfirmPassword ? "text" : "password"}
                                autoComplete="off"
                                placeholder="Confirm new password"
                                value={technicianPassword.confirmPassword.value}
                                onChange={(e) =>
                                  handlePasswordInputChange(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>
                                  handleOnBlurPassForm(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                                required
                                maxLength={16}
                              />
                              <InputGroupAddon addonType="append">
                                <InputGroupText
                                  className="d-flex align-items-center pointer"
                                  onClick={() =>
                                    setShowConfirmPassword((prev) => !prev)
                                  }
                                >
                                  {showConfirmPassword ? (
                                    <i className="fa fa-eye-slash" />
                                  ) : (
                                    <i className="fa fa-eye" />
                                  )}
                                </InputGroupText>
                              </InputGroupAddon>
                            </InputGroup>
                            {technicianPassword.confirmPassword.error && (
                              <small className="validation-error">
                                {technicianPassword.confirmPassword.error}
                              </small>
                            )}
                          </FormGroup>
                          <div className="d-flex justify-content-start">
                            <Button
                              color="default"
                              type="submit"
                              className="px-4 shadow-sm"
                              onClick={() => {
                                handlePasswordSaveClick();
                              }}
                              disabled={Object.values(technicianPassword).some(
                                (item) => item.error !== ""
                              )}
                            >
                              {showLoaderPasswordSave ? (
                                <i className="fa fa-spinner fa-spin fa-lg text-white" />
                              ) : (
                                "Save"
                              )}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                )}
              </CardBody>
            </>
          </Card>
        </Row>
      </Container>
      <TechnicianLeaveModal
        isOpen={leaveModal.isOpen}
        mode={leaveModal.mode}
        data={leaveModal.data} // optional: pass data when editing
        onClose={handleCloseLeaveModal}
        technicianID={decodedId}
      />
    </>
  );
}

export default TechnicianDetails;
